var className = "trans-bg";
var scrollTrigger = 60;
window.onscroll = function() {
  if (window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger) {
    document.getElementsByTagName("sticky-header")[0].classList.add(className);
  } else {
    document.getElementsByTagName("sticky-header")[0].classList.remove(className);
  }
};

    var accordions = document.getElementsByClassName("accordin");
    if (window.innerWidth < 768) {
    for (var i = 0; i < accordions.length; i++) {
      accordions[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      }, 800);
    };
    };
// -==--=-=-= collection page -==-=-=--=
  $(document).ready(function() {
     if ($(window).width() < 768) {
       $('#product-grid').attr('row', 'two-per-row');
        $('.two-per-row.layout-button').addClass('active');
     } else{
        $('.three-per-row.layout-button').addClass('active');
     };
    
    $('.layout-button').on('click', function() {
      $('.layout-button').removeClass('active');
      $(this).addClass('active');
      const layoutClass = $(this).attr('class').split(' ')[0];
      $('#product-grid').attr('row', layoutClass);
    });

    
    $('.filter-button').on('click', function() {
      $('#main-collection-filters').toggleClass('hidden');
      
    });


    setTimeout(function(){ flkty.resize(); }, 100);
  });

